package eu.codlab.safearea.theme

import androidx.compose.runtime.Composable

@Composable
actual fun rememberWindowInsetsController(): WindowInsetsController? {
    return null
}
